import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { pageChanged } from '../../../../../data/redux/page_details/actions';
import { getIsMobile } from '../../../../../data/redux/page_details/selectors';
import { getEventHistogram, updateEventState } from '../../../../../data/redux/event_details/actions';

import { APP_PAGES } from '../../../../../data/config/constants';

import CustomHeader from '../../../../../components/customheader';
import Graph from '../../../components/charts/graph';
import CardContainer from '../../../components/cardcontainer';
import { histogramLabelFormatter } from '../../../../../data/config/utils';

class EventAnalytics extends Component {
  componentWillMount() {
    const { actions } = this.props;
    actions.pageChanged(APP_PAGES.EVENT_ANALYTICS, APP_PAGES.ANALYTICS);
  }

  componentDidMount() {
    const { actions, analytics } = this.props;
    if (analytics.histogram.length === 0) {
      actions.getEventHistogram(analytics.histogram_filters);
    }
  }

  onChangeDateRange = date_range => {
    const { actions } = this.props;
    const payload = {
      startDate: date_range[0],
      endDate: date_range[1],
    };
    actions.getEventHistogram(payload, () => {
      actions.updateEventState(date_range[0], "analytics.histogram_filters.startDate");
      actions.updateEventState(date_range[1], "analytics.histogram_filters.endDate");
    });
  };

  renderEventHistogram = () => {
    const { analytics, loaders, is_mobile } = this.props;
    const custom_header_props = {
      title: "Event Histogram",
    };
    return (
      <CardContainer
        custom_header_props={custom_header_props}
        container_height={450}
        load_error={loaders.histogram_load_error}
        loading={loaders.histogram_loading}
        emtpy_condition={analytics.histogram.length === 0}
        show_custom_header
      >
        <Graph
          type='interval'
          data={analytics.histogram}
          scale={analytics.histogram_scale}
          x_axis={analytics.histogram_axis.x_axis}
          y_axis={analytics.histogram_axis.y_axis}
          x_axis_props={{
            label: {
              offset: 8,
              formatter: histogramLabelFormatter
            }
          }}
          height={350 + (analytics.histogram.length / 10) * 300}
          padding={is_mobile ? [20, 20, 20, 80] : ['auto', 20, 'auto', 'auto']}
          color_key={analytics.histogram_axis.x_axis}
          coord_props={{ transpose: true, reflect: 'y' }}
          tooltip_props={{
            custom: true,
            itemTpl: '<span><span style="color:{color}">&#8226</span><span> Count : {value}</span></span>'
          }}
          forceFit
        />
      </CardContainer>
    );
  };

  render() {
    const { analytics } = this.props;
    return (
      <div className="ori-lr-pad-10 oriEventAnalyticsContainer">
        <CustomHeader
          title="Event Analytics"
          date_range={[analytics.histogram_filters.startDate, analytics.histogram_filters.endDate]}
          onChangeDateRange={this.onChangeDateRange}
          bottom_bordered
          show_date_range
        />
        {this.renderEventHistogram()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    analytics: state.event_details.analytics,
    loaders: state.event_details.loaders,
    is_mobile: getIsMobile(state),
  };
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      pageChanged,
      updateEventState,
      getEventHistogram,
    }, dispatch),
  };
}

EventAnalytics.propTypes = {
  is_mobile: PropTypes.bool,
  actions: PropTypes.object,
  analytics: PropTypes.object,
  loaders: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(EventAnalytics);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/eventanalytics/index.js